const AlertCircleFilled = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "16"}
      height={size || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g id="alert-circle">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color || "#DC3636"}
          d="M7.99996 0.666504C3.94987 0.666504 0.666626 3.94975 0.666626 7.99984C0.666626 12.0499 3.94987 15.3332 7.99996 15.3332C12.05 15.3332 15.3333 12.0499 15.3333 7.99984C15.3333 3.94975 12.05 0.666504 7.99996 0.666504ZM8.66663 5.33317C8.66663 4.96498 8.36815 4.6665 7.99996 4.6665C7.63177 4.6665 7.33329 4.96498 7.33329 5.33317V7.99984C7.33329 8.36803 7.63177 8.6665 7.99996 8.6665C8.36815 8.6665 8.66663 8.36803 8.66663 7.99984V5.33317ZM7.99996 9.99984C7.63177 9.99984 7.33329 10.2983 7.33329 10.6665C7.33329 11.0347 7.63177 11.3332 7.99996 11.3332H8.00663C8.37482 11.3332 8.67329 11.0347 8.67329 10.6665C8.67329 10.2983 8.37482 9.99984 8.00663 9.99984H7.99996Z"
        />
      </g>
    </svg>
  );
};

export default AlertCircleFilled;
